import React from 'react';
import { useTranslation } from 'react-i18next';

interface TwoFactorHeaderProps {
  phoneNumber: string;
  onChangeNumber: () => void;
}

const Header: React.FC<TwoFactorHeaderProps> = ({ phoneNumber, onChangeNumber }) => {
  const { t } = useTranslation();

  const maskedNumber = phoneNumber && phoneNumber.length >= 6 
    ? `+91 ${phoneNumber.slice(0, 2)}****${phoneNumber.slice(-4)}`
    : phoneNumber;

  return (
    <>
      <h4 className="mb-1">{t('login.pageTexts.twoFactor.header')}</h4>
      <p className="mb-5">
        {t('login.pageTexts.twoFactor.subHeader')}
        <span className="d-block mt-1 mb-0 h6">
            {maskedNumber}
            <small className="ms-2 text-primary" style={{ cursor: 'pointer' }} onClick={onChangeNumber}><i className="ri-pencil-line me-1"></i>Change</small>
        </span>
      </p>
      <p className="mb-0">{t('login.pageTexts.twoFactor.instruction')}</p>
    </>
  );
};

export default Header;
